var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0104 18.0312C14.6927 21.349 9.30734 21.349 5.98959 18.0312C2.67185 14.7135 3.98813 9.34618 3.98813 9.34618M3.98813 9.34618L1.73422 11.6001M3.98813 9.34618L6.02565 11.3837M5.98959 6.01041C9.30734 2.69266 14.6686 2.66862 18.0104 6.01041C22.0193 10.0193 20.679 15.3626 20.679 15.3626M20.679 15.3626L22.9329 13.1087M20.679 15.3626L18.6776 13.3611",
    stroke: "#13151A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.154 12.8315L10.154 12.8315L10.1575 12.8351C10.663 13.3393 11.2878 13.6 12 13.6C12.7123 13.6 13.3365 13.3391 13.8393 12.8333C14.341 12.3287 14.6 11.7052 14.6 10.9951C14.6 10.2848 14.3408 9.66201 13.8375 9.15998L13.4138 9.58477L13.8375 9.15998C13.3343 8.658 12.7107 8.4 12 8.4C11.2893 8.4 10.6657 8.658 10.1625 9.15998C9.65919 9.66201 9.4 10.2848 9.4 10.9951C9.4 11.7036 9.65617 12.3265 10.154 12.8315Z",
    stroke: "#13151A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9403 18.0002C17.7648 17.0886 17.1983 16.2917 16.2408 15.6095C15.0684 14.7741 13.6547 14.3564 11.9995 14.3564C10.3443 14.3564 8.93051 14.7741 7.75809 15.6095C6.80064 16.2917 6.23415 17.0886 6.05859 18.0002",
    stroke: "#13151A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSwitcher);
export default __webpack_public_path__ + "static/media/account-switcher.50850bec2ebf01071fb02ab20cdec8d2.svg";
export { ForwardRef as ReactComponent };